import { render, staticRenderFns } from "./ConsentOnePlatformCreate.vue?vue&type=template&id=0730ce56&scoped=true&"
import script from "./ConsentOnePlatformCreate.vue?vue&type=script&lang=js&"
export * from "./ConsentOnePlatformCreate.vue?vue&type=script&lang=js&"
import style0 from "./ConsentOnePlatformCreate.vue?vue&type=style&index=0&id=0730ce56&prod&scoped=true&lang=css&"
import style1 from "./ConsentOnePlatformCreate.vue?vue&type=style&index=1&id=0730ce56&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0730ce56",
  null
  
)

export default component.exports